import { render, staticRenderFns } from "./discountsModal.vue?vue&type=template&id=cadb0fec&"
import script from "./discountsModal.vue?vue&type=script&lang=js&"
export * from "./discountsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports